/*
 * @Descripttion: 右侧导航公共逻辑
 * @version: V1.0
 * @Author: yuanxing(01407381)
 * @Date: 2022-07-26 11:00:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-12-07 14:26:46
 */
import { mapState } from 'vuex'
import { urlEnhanceLang } from '@/utils/utils'
import { setCookieCommon } from '@/utils/auth'
import allUrls from '@/utils/config'
import navConfig from '@/modules/config/nav'
import IcasLoginService from '@/services/icas-login'
import {
  ExpressserviceHoverbarClick,
  EcommerceserviceHoverbarClick,
  SFBuyserviceHoverbarClick,
  CooperateHoverbarClick,
} from '@/reporter/track'
const mixin = {
  data() {
    return {
      backtopHide: false,
      backItems: navConfig[this.$route.params.site].navList,
      tabList: navConfig[this.$route.params.site].tabList,
      kefu: navConfig[this.$route.params.site].kefu,
      customerUrl: navConfig[this.$route.params.site].customerUrl,
      site: '',
      lang: '',
      trackMap: {
        express: ExpressserviceHoverbarClick,
        ec: EcommerceserviceHoverbarClick,
        sfbuy: SFBuyserviceHoverbarClick,
        cooperate: CooperateHoverbarClick,
      },
      icasLoginService: null,
    }
  },
  computed: {
    ...mapState({
      resizeInfo: (state) => state.resizeInfo,
      isHome: (state) => state.isHome,
      locale: (state) => state.locale,
      loginToken: (state) => state.loginToken,
      loginUser: (state) => state.loginUser,
    }),
  },
  created() {
    this.site = this.$route.params.site
    this.lang = this.$route.params.lang
  },
  watch: {
    '$route.path': {
      handler(newPath, oldPath) {
        const newSite = this.$route.params.site
        const oldSite = oldPath ? oldPath.split('/')[1] : ''
        if (newSite && newSite !== oldSite) {
          this.site = newSite
          this.lang = this.$route.params.lang
          this.initNavConfig()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // 初始化ICAS登录服务
    if (this.$icasSDK) {
      this.icasLoginService = new IcasLoginService(this.$icasSDK)
    }
  },
  methods: {
    /**
     * 初始化导航配置并从 CMS 动态获取 kefu URL
     */
    async initNavConfig() {
      const siteConfig = navConfig[this.site] || {}
      this.backItems = siteConfig.navList || []
      this.tabList = siteConfig.tabList || []
      this.kefu = siteConfig.kefu || null
      this.customerUrl = siteConfig.customerUrl || ''

      // 从 CMS 动态获取 Instadesk 客服地址（完整 URL），实现测试/正式环境自适应
      // 若 CMS 获取失败，使用 nav/index.js 中的硬编码地址作为降级
      const kefu = this.kefu
      if (kefu && typeof kefu === 'object') {
        const resolvedKefu = {}
        for (const lang of Object.keys(kefu)) {
          if (typeof kefu[lang] === 'string' && kefu[lang].includes('instadesk.com')) {
            // Instadesk 地址：尝试从 CMS 获取对应环境的完整 URL
            const cmsConfigKey = `kefu_url_${this.site}_${lang}`
            try {
              const cmsUrl = await this.$API.support.getSysConfig(cmsConfigKey)
              if (cmsUrl && cmsUrl.startsWith('http')) {
                resolvedKefu[lang] = cmsUrl
              } else {
                // CMS 返回为空或格式不对，使用硬编码地址
                resolvedKefu[lang] = kefu[lang]
              }
            } catch (e) {
              // CMS 接口异常，使用硬编码地址
              console.warn(`[rightNav] 获取 CMS 配置失败: ${cmsConfigKey}`, e)
              resolvedKefu[lang] = kefu[lang]
            }
          } else if (kefu[lang]) {
            // 非 Instadesk 地址（如 WhatsApp、GB/US/IN 旧地址），保留原配置
            resolvedKefu[lang] = kefu[lang]
          }
        }
        if (Object.keys(resolvedKefu).length > 0) {
          this.kefu = resolvedKefu
        }
      }
    },
    external(e) {
      if (e === 4) {
        // 商务合作
        this.trackFn('cooperate')
        const jumpUrl = urlEnhanceLang({
          lang: this.locale,
          url: this.customerUrl, // allUrls.iuopCustomerUrl,
        })
        window.open(jumpUrl)
      } else if (e === 3) {
        // 还需添加移动端判断
        if (this.resizeInfo.isMobile === true) {
          // 移动端
          if (this.tabList.length) {
            this.$refs.drawerRef.visible = true
          } else {
            this.kefu && window.open(this.kefu[this.lang])
          }
        } else {
          this.kefu && window.open(this.kefu[this.lang])
        }
      } else if (e === 6) {
        const routeUrl = this.$router.resolve({
          path: `/${this.site}/${this.lang}/support/suggestion`,
          query: {
            sceneCode: 'rightNav', // 场景码key
          },
        })
        location.href = routeUrl.href
      }
    },
    /**
     * 打开ICAS登录对话框
     * 流程：
     * 1. 检查服务初始化
     * 2. 检查配置是否完整
     * 3. 打开登录对话框
     * 4. 登录成功后打开客服
     * 5. 任何失败都进行降级处理
     */
    async openIcasLoginDialog(channelId) {
      // 检查服务是否初始化
      if (!this.icasLoginService) {
        console.error('ICAS服务未初始化')
        await this.fallbackOpenCustomerService(channelId, 'common.service.initFailed')
        return
      }

      // 检查ICAS配置
      if (!window.icasConfig || !window.icasConfig.config) {
        console.error('ICAS配置未初始化')
        await this.fallbackOpenCustomerService(channelId, 'common.service.openFailed')
        return
      }

      // 构建登录配置
      const config = {
        env: window.icasConfig.currentEnv || 'uat',
        language: this.locale?.includes('en') ? 'en' : 'zh-CN',
        wechat: window.icasConfig.config?.wechat ?? false,
        whatsapp: window.icasConfig.config?.whatsapp ?? false,
        countryCode: window.icasConfig.config?.countryCode ?? 'CN',
        sysCode: window.icasConfig.config?.sysCode ?? 'IBU-OWT-CORE',
        redirectUrl: window.location.href,
        loadCaptcha: window.icasConfig.config?.loadCaptcha ?? '1',
        platform: this.resizeInfo.isMobile ? 'mobile' : 'pc',
      }

      // 打开登录对话框
      try {
        const dialog = await this.icasLoginService.openLoginDialog(config, {
          onSuccess: (event) => this.handleIcasLoginSuccess(event, channelId),
          onEvent: (event) => this.handleIcasLoginEvent(event),
          onError: (event) => this.handleIcasLoginError(event),
        })

        // 对话框打开失败的降级处理
        if (!dialog) {
          await this.fallbackOpenCustomerService(channelId)
        }
      } catch (error) {
        console.error('ICAS登录对话框打开失败:', error)
        await this.fallbackOpenCustomerService(channelId)
      }
    },

    /**
     * ICAS登录成功回调
     */
    handleIcasLoginSuccess(event, channelId) {
      console.log('✅ ICAS登录成功:', event)
      const token = this.icasLoginService.getTokenFromEvent(event)
      const userInfo = this.icasLoginService.getUserInfoFromEvent(event)

      if (!token) return

      // 保存登录信息到store
      this.$store.commit('saveLoginToken', token)
      this.$store.commit('saveLoginInfo', userInfo)

      // 将ICAS回调参数写入cookie
      const uid = event?.data?.uid
      const phoneNumberSensitization = event?.data?.phoneNumberSensitization

      if (uid) setCookieCommon('loginUserId', uid)
      if (token) setCookieCommon('userToken', token)
      if (phoneNumberSensitization) setCookieCommon('loginUser', phoneNumberSensitization)

      // 登录成功后打开客服窗口
      this.$nextTick(() => {
        this.openCustomerServiceWindow(channelId).catch((error) => {
          console.error('登录后打开客服失败:', error)
          this.$message?.error?.(this.$t('common.service.timeout'))
        })
      })
    },

    /**
     * ICAS登录事件回调
     */
    handleIcasLoginEvent(event) {
      if (event.type === 'failed') {
        console.error('❌ ICAS登录失败:', event)
        this.$message?.error?.(this.$t('common.service.loginFailed'))
      }
    },

    /**
     * ICAS登录错误回调
     */
    handleIcasLoginError(event) {
      console.error('❌ ICAS登录错误:', event)
    },

    /**
     * 降级处理：打开客服窗口
     */
    async fallbackOpenCustomerService(channelId, errorMsgKey = 'common.tips.serviceUnavailable') {
      try {
        await this.openCustomerServiceWindow(channelId)
      } catch (error) {
        console.error('降级打开客服失败:', error)
        this.$message?.error?.(this.$t(errorMsgKey))
      }
    },

    /**
     * 打开客服窗口（新浏览器tab）
     * 调用API获取客服URL
     */
    async openCustomerServiceWindow(channelId) {
      try {
        // 从 store 中获取登录 token
        const token = this.$store.state.loginToken

        console.log('📞 准备打开客服系统', {
          hasToken: !!token,
          site: this.site,
        })

        // 调用API获取客服URL
        const params = {
          channelId: channelId || (window.customerServiceConfig?.sfBuyChannelId || ''),
        }

        // 仅有 token 时才传递 token 参数
        if (token) {
          params.token = token
        }

        try {
          const response = await this.$axios.get(
            '/site/core-service/web/odpService/getUrl',
            { params }
          )
          const customerServiceUrl = response?.result

          if (!customerServiceUrl) {
            console.warn('❌ 客服URL为空')
            throw new Error('Failed to get customer service URL')
          }

          console.log('✅ 客服URL已获取，打开新窗口')
          if (this.resizeInfo.isMobile) {
            window.location.href = customerServiceUrl
          } else {
            // 在新浏览器tab打开
            window.open(
              customerServiceUrl,
              'customer-service-window',
              'height=600,width=800,top=0,left=0,toolbar=no,menubar=no,location=no,resizable=yes,status=yes'
            )
          }
        } catch (apiError) {
          console.error('❌ 获取客服URL失败:', apiError)
          throw apiError
        }
      } catch (error) {
        console.error('❌ 打开客服系统失败:', error)
        this.$message?.error?.(this.$t('common.service.openFailed'))
        throw error
      }
    },
    trackFn(name, properties) {
      if (this.trackMap[name]) {
        this.trackMap[name](properties)
      }
    },
    async handleLive800() {
      try {
        await this.live800()
      } catch (error) {
        console.error('打开物流客服失败:', error)
        this.$message?.error?.(this.$t('common.service.openFailed'))
      }
    },

    async handleSfBuyService() {
      try {
        await this.sfBuyService()
      } catch (error) {
        console.error('打开快递客服失败:', error)
        this.$message?.error?.(this.$t('common.service.openFailed'))
      }
    },

    handleService(type) {
      this.trackFn(type)
      // 中国内地 - 添加错误处理
      if (type === 'express') {
        this.handleLive800()
      } else if (type === 'ec') {
        this.openTencent()
      } else if (type === 'sfbuy') {
        this.handleSfBuyService()
      } else if (type === 'international') {
        // 国际件
        this.openIdService('international')
      } else if (type === 'domestic') {
        // 本地件
        this.openIdService('domestic')
      }
    },
    // sfbuy客服
    async sfBuyService() {
      // let url = window.location.href
      // url = encodeURIComponent(url)
      // const url1 = allUrls.ocs2odpUrlSfbuy
      // // window.g.ocs2odpUrl +
      // // '/app/init?orgName=sy&channelId=140&clientType=1&accountId='
      // const url2 = '&pagereferrer='
      // window.open(
      //   url1 + url + url2 + url,
      //   'newwindow',
      //   'height=600,width=800,top=0,left=0,toolbar=no,menubar=no,location=no,resizable=yes,status=yes'
      // )
      try {
        // 检查是否已登录
        const channelId = window.customerServiceConfig.sfBuyChannelId
        if (this.loginToken && this.loginUser) {
          // 已登录 - 直接打开客服窗口
          await this.openCustomerServiceWindow(channelId)
        } else {
          // 未登录 - 唤起 ICAS 登录
          await this.openIcasLoginDialog(channelId)
        }
      } catch (error) {
        console.error('❌ 快递咨询客服处理失败:', error)
        // 降级处理 - 直接打开客服（如果 API 不可用）
        this.$message?.error?.(this.$t('common.service.openFailed'))
      }
    },
    // 物流客服
    /**
     * 快递咨询客服 - 物流客服
     * 功能：
     * 1. 未登录用户 → 唤起 ICAS 登录框
     * 2. 登录成功/已登录 → 调用 API 获取客服 URL（可选传递加密手机号）
     * 3. 在新浏览器 tab 打开客服系统
     */
    async live800() {
      try {
        // 检查是否已登录
        const channelId = window.customerServiceConfig.liveChannelId
        if (this.loginToken && this.loginUser) {
          // 已登录 - 直接打开客服窗口
          
          await this.openCustomerServiceWindow(channelId)
        } else {
          // 未登录 - 唤起 ICAS 登录
          await this.openIcasLoginDialog(channelId)
        }
      } catch (error) {
        console.error('❌ 快递咨询客服处理失败:', error)
        // 降级处理 - 直接打开客服（如果 API 不可用）
        this.$message?.error?.(this.$t('common.service.openFailed'))
      }
    },
    // 电商
    openTencent() {
      const url = allUrls.ocs2odpUrlTencent
      // 'tencent://message/?uin=800013683&Site=%E7%BD%91%E7%AB%99&Menu=yes'
      window.open(url)
    },

    // 印尼站在线客服（优先 CMS 配置，失败降级硬编码地址）
    async openIdService(type) {
      const fallbackUrl =
        type === 'international'
          ? 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=j2iYJbJFFzUz&showChat=true&layout=true'
          : 'https://u-sfexpress.instadesk.com/dzfront/web/home?token=ZBjaemJb2Ubi&showChat=true&layout=true'
      const configKey =
        type === 'international' ? 'kefu_url_id_international' : 'kefu_url_id_domestic'
      try {
        const cmsUrl = await this.$API.support.getSysConfig(configKey)
        if (cmsUrl && cmsUrl.startsWith('http')) {
          window.open(cmsUrl)
        } else {
          window.open(fallbackUrl)
        }
      } catch (e) {
        console.warn(`[rightNav] 获取印尼站 CMS 配置失败: ${configKey}`, e)
        window.open(fallbackUrl)
      }
    },
  },

  beforeDestroy() {
    if (this.icasLoginService) {
      this.icasLoginService.destroy()
    }
  },
}
export default mixin
